import React, { useEffect, useState } from "react";
import "./PhoneNumberInput.scss";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/useAppSelector";

interface PhoneNumberInputProps {
  selectedCode: string;
  setSelectedCode: (code: string) => void;
  phoneNumber: { value: string; isValid: boolean };
  setPhoneNumber: (value: { value: string; isValid: boolean }) => void;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  selectedCode,
  setSelectedCode,
  phoneNumber,
  setPhoneNumber,
}) => {
  const { t } = useTranslation();

  const { allCountries } = useAppSelector((state) => state.countriesSlice);
  const [phoneCountryCodes, setPhoneCountryCodes] = useState<
    { id: string; label: string; cca2: string }[]
  >([]);

  useEffect(() => {
    if (allCountries.length > 0) {
      const changedCountriesForCountryCodes = allCountries
        .map((el) => {
          return {
            id:
              (el.idd.root ? el.idd.root : "+999") +
              (el.idd.suffixes.length ? el.idd.suffixes[0] : ""),
            label:
              (el.idd.root ? el.idd.root : "+999") +
              (el.idd.suffixes.length ? el.idd.suffixes[0] : "") +
              " " +
              el.name.common,
            cca2: el.cca2,
          };
        })
        .sort((a, b) =>
          a.cca2.toLowerCase() < b.cca2.toLowerCase()
            ? -1
            : a.cca2.toLowerCase() > b.cca2.toLowerCase()
              ? 1
              : 0
        );
      setPhoneCountryCodes(changedCountriesForCountryCodes);
    }
  }, [allCountries]);

  return (
    <div className={"phone-number-input"}>
      <label>{t("PhoneNumber")}</label>
      <div className={`wrapper ${!phoneNumber.isValid && "invalid"}`}>
        <select
          className={"select"}
          onChange={(e) => setSelectedCode(e.target.value)}
          value={selectedCode}
        >
          {phoneCountryCodes.map((country) => (
            <option key={country.cca2} value={country.id}>
              {country.cca2}
            </option>
          ))}
        </select>
        <input
          className={"input"}
          type="tel"
          value={phoneNumber.value}
          onChange={(e) => setPhoneNumber({ value: e.target.value, isValid: true })}
          placeholder={selectedCode + " (555) 000-0000"}
        />
      </div>
    </div>
  );
};

export default PhoneNumberInput;
